var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _g, _path132, _g2, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebAppContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 510,
    height: 380,
    viewBox: "0 0 510 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M510 333.938H0.0146484V334.193H510V333.938Z",
    fill: "#C9DDF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M458.9 350.349H425.118V350.604H458.9V350.349Z",
    fill: "#C9DDF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M337.849 353.124H328.985V353.379H337.849V353.124Z",
    fill: "#C9DDF1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M424.098 340.884H404.524V341.139H424.098V340.884Z",
    fill: "#C9DDF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.575 342.598H53.5225V342.853H97.575V342.598Z",
    fill: "#C9DDF1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.119 342.598H106.663V342.853H113.119V342.598Z",
    fill: "#C9DDF1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M229.661 346.902H134.11V347.157H229.661V346.902Z",
    fill: "#C9DDF1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M361.013 44.0013C361.014 43.3425 360.885 42.69 360.632 42.0815C360.379 41.4731 360.008 40.9209 359.54 40.457C359.073 39.993 358.518 39.6265 357.907 39.3788C357.297 39.131 356.643 39.0069 355.984 39.0137C355.498 39.0135 355.013 39.0822 354.546 39.2177C354.62 38.711 354.657 38.1997 354.658 37.6877C354.658 34.895 353.552 32.216 351.581 30.2374C349.61 28.2588 346.935 27.1418 344.142 27.131C343.489 27.1317 342.837 27.1897 342.194 27.3044C341.153 25.5935 339.584 24.2677 337.723 23.527C335.862 22.7863 333.811 22.6709 331.878 23.1983C329.946 23.7257 328.238 24.8672 327.012 26.4505C325.785 28.0339 325.107 29.9732 325.079 31.9759H324.926C322.72 32.0523 320.629 32.9825 319.095 34.5704C317.561 36.1583 316.704 38.2798 316.704 40.4875C316.704 42.6953 317.561 44.8168 319.095 46.4047C320.629 47.9926 322.72 48.9228 324.926 48.9992H356.158C357.458 48.962 358.693 48.4191 359.6 47.4858C360.506 46.5525 361.013 45.3025 361.013 44.0013Z",
    fill: "#98ACC1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M342.674 51.4574V41.7371H334.748V51.4574H328.292L338.716 60.2699L349.14 51.4574H342.674Z",
    fill: "#DCEAF8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M204.702 58.7094C204.702 55.9005 203.587 53.2066 201.601 51.2194C199.616 49.2323 196.923 48.1146 194.115 48.1119C193.078 48.1134 192.048 48.2645 191.055 48.5607C191.219 47.484 191.301 46.3962 191.299 45.307C191.299 39.3557 188.935 33.6482 184.727 29.44C180.519 25.2318 174.811 22.8677 168.86 22.8677C167.474 22.8673 166.091 22.9971 164.729 23.2552C162.519 19.6206 159.186 16.8035 155.234 15.2292C151.282 13.6549 146.925 13.4089 142.821 14.5282C138.717 15.6475 135.089 18.0714 132.483 21.4341C129.877 24.7968 128.436 28.9158 128.377 33.1693H128.051C125.642 33.1121 123.246 33.5371 121.004 34.4195C118.761 35.3018 116.718 36.6236 114.994 38.3071C113.27 39.9906 111.9 42.0018 110.965 44.2225C110.03 46.4432 109.548 48.8285 109.548 51.2381C109.548 53.6477 110.03 56.033 110.965 58.2537C111.9 60.4744 113.27 62.4857 114.994 64.1692C116.718 65.8527 118.761 67.1745 121.004 68.0568C123.246 68.9391 125.642 69.3641 128.051 69.3069H194.4C197.16 69.2324 199.782 68.0828 201.706 66.1031C203.63 64.1234 204.705 61.4703 204.702 58.7094Z",
    fill: "#98ACC1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M148.931 59.5253V80.1797H165.77V59.5253H179.489L157.345 40.8191L135.212 59.5253H148.931Z",
    fill: "#DCEAF8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M213.157 110.289V82.5154H298.202V110.014",
    stroke: "#DCEAF8",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M256.935 56.343V110.218",
    stroke: "#DCEAF8",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M271.409 45.7659H242.482C241.812 45.7659 241.269 46.3093 241.269 46.9796V64.1865C241.269 64.8569 241.812 65.4003 242.482 65.4003H271.409C272.079 65.4003 272.622 64.8569 272.622 64.1865V46.9796C272.622 46.3093 272.079 45.7659 271.409 45.7659Z",
    fill: "#98ACC1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M271.102 48.071H242.777C242.54 48.071 242.349 48.2628 242.349 48.4994V64.1866C242.349 64.4232 242.54 64.615 242.777 64.615H271.102C271.338 64.615 271.53 64.4232 271.53 64.1866V48.4994C271.53 48.2628 271.338 48.071 271.102 48.071Z",
    fill: "#DCEAF8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M227.622 107.77H198.695C198.025 107.77 197.481 108.313 197.481 108.984V126.191C197.481 126.861 198.025 127.404 198.695 127.404H227.622C228.292 127.404 228.835 126.861 228.835 126.191V108.984C228.835 108.313 228.292 107.77 227.622 107.77Z",
    fill: "#98ACC1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M227.314 110.075H198.99C198.753 110.075 198.562 110.267 198.562 110.503V126.19C198.562 126.427 198.753 126.619 198.99 126.619H227.314C227.551 126.619 227.743 126.427 227.743 126.19V110.503C227.743 110.267 227.551 110.075 227.314 110.075Z",
    fill: "#DCEAF8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M271.409 107.77H242.482C241.812 107.77 241.269 108.313 241.269 108.984V126.191C241.269 126.861 241.812 127.404 242.482 127.404H271.409C272.079 127.404 272.622 126.861 272.622 126.191V108.984C272.622 108.313 272.079 107.77 271.409 107.77Z",
    fill: "#98ACC1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M271.102 110.075H242.777C242.54 110.075 242.349 110.267 242.349 110.503V126.19C242.349 126.427 242.54 126.619 242.777 126.619H271.102C271.338 126.619 271.53 126.427 271.53 126.19V110.503C271.53 110.267 271.338 110.075 271.102 110.075Z",
    fill: "#DCEAF8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M312.737 107.77H283.81C283.14 107.77 282.597 108.313 282.597 108.984V126.191C282.597 126.861 283.14 127.404 283.81 127.404H312.737C313.407 127.404 313.951 126.861 313.951 126.191V108.984C313.951 108.313 313.407 107.77 312.737 107.77Z",
    fill: "#98ACC1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M312.432 110.075H284.107C283.871 110.075 283.679 110.267 283.679 110.503V126.19C283.679 126.427 283.871 126.619 284.107 126.619H312.432C312.668 126.619 312.86 126.427 312.86 126.19V110.503C312.86 110.267 312.668 110.075 312.432 110.075Z",
    fill: "#DCEAF8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M256.349 74.1016L248.517 81.9341C248.194 82.2567 248.194 82.7799 248.517 83.1025L256.349 90.935C256.672 91.2577 257.195 91.2577 257.518 90.935L265.35 83.1025C265.673 82.7799 265.673 82.2567 265.35 81.9341L257.518 74.1016C257.195 73.7789 256.672 73.7789 256.349 74.1016Z",
    fill: "#DCEAF8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M90.8839 69.001H70.4743C69.9842 69.001 69.5869 69.3983 69.5869 69.8883V81.4038C69.5869 81.8939 69.9842 82.2912 70.4743 82.2912H90.8839C91.374 82.2912 91.7713 81.8939 91.7713 81.4038V69.8883C91.7713 69.3983 91.374 69.001 90.8839 69.001Z",
    fill: "#DCEAF8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3088 97.5906H59.1423C58.6522 97.5906 58.2549 97.9879 58.2549 98.478V106.852C58.2549 107.342 58.6522 107.739 59.1423 107.739H75.3088C75.7989 107.739 76.1962 107.342 76.1962 106.852V98.478C76.1962 97.9879 75.7989 97.5906 75.3088 97.5906Z",
    fill: "#DCEAF8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M102.531 97.5906H86.3649C85.8748 97.5906 85.4775 97.9879 85.4775 98.478V106.852C85.4775 107.342 85.8748 107.739 86.3649 107.739H102.531C103.022 107.739 103.419 107.342 103.419 106.852V98.478C103.419 97.9879 103.022 97.5906 102.531 97.5906Z",
    fill: "#DCEAF8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7936 119.071H78.154C77.6639 119.071 77.2666 119.469 77.2666 119.959V126.854C77.2666 127.344 77.6639 127.741 78.154 127.741H85.7936C86.2836 127.741 86.6809 127.344 86.6809 126.854V119.959C86.6809 119.469 86.2836 119.071 85.7936 119.071Z",
    fill: "#DCEAF8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7486 119.071H90.1091C89.619 119.071 89.2217 119.469 89.2217 119.959V126.854C89.2217 127.344 89.619 127.741 90.1091 127.741H97.7486C98.2387 127.741 98.636 127.344 98.636 126.854V119.959C98.636 119.469 98.2387 119.071 97.7486 119.071Z",
    fill: "#DCEAF8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M109.712 119.071H102.072C101.582 119.071 101.185 119.469 101.185 119.959V126.854C101.185 127.344 101.582 127.741 102.072 127.741H109.712C110.202 127.741 110.599 127.344 110.599 126.854V119.959C110.599 119.469 110.202 119.071 109.712 119.071Z",
    fill: "#DCEAF8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1217 119.071H50.4821C49.992 119.071 49.5947 119.469 49.5947 119.959V126.854C49.5947 127.344 49.992 127.741 50.4821 127.741H58.1217C58.6118 127.741 59.009 127.344 59.009 126.854V119.959C59.009 119.469 58.6118 119.071 58.1217 119.071Z",
    fill: "#DCEAF8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0963 119.071H63.4567C62.9666 119.071 62.5693 119.469 62.5693 119.959V126.854C62.5693 127.344 62.9666 127.741 63.4567 127.741H71.0963C71.5864 127.741 71.9837 127.344 71.9837 126.854V119.959C71.9837 119.469 71.5864 119.071 71.0963 119.071Z",
    fill: "#DCEAF8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4225 97.5906H94.4425V90.4508H81.1829V82.291H80.1629V90.4508H66.9033V97.5906H67.9233V91.4707H93.4225V97.5906Z",
    fill: "#DCEAF8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9051 113.91H53.6455V119.01H54.6655V114.93H66.9051V119.01H67.9251V107.79H66.9051V113.91Z",
    fill: "#DCEAF8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4442 114.93V107.79H93.4242V114.93H81.1846V119.01H82.2045V115.95H93.4242V119.01H94.4442V115.95H105.664V119.01H106.684V114.93H94.4442Z",
    fill: "#DCEAF8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M388.624 72.1933V79.5575L392.398 79.9145C392.904 82.3283 393.859 84.6256 395.213 86.6871L392.785 89.6144L397.967 94.7959L400.894 92.3683C402.954 93.7264 405.252 94.6816 407.667 95.1834L408.003 98.9369H415.327L415.684 95.163C418.099 94.6612 420.397 93.706 422.456 92.3479L425.384 94.7754L430.565 89.594L428.148 86.6973C429.502 84.6358 430.457 82.3385 430.963 79.9247L434.737 79.5677V72.2443L430.963 71.8873C430.459 69.4761 429.503 67.1818 428.148 65.1249L430.575 62.1976L425.394 57.0162L422.467 59.4335C420.405 58.0796 418.108 57.1247 415.694 56.6184L415.337 52.8445H408.003L407.646 56.6184C405.233 57.1247 402.935 58.0796 400.874 59.4335L397.947 57.0162L392.765 62.1976L395.193 65.1249C393.837 67.1818 392.882 69.4761 392.378 71.8873L388.624 72.1933ZM411.686 65.9409C413.649 65.9409 415.568 66.5232 417.2 67.6142C418.833 68.7051 420.105 70.2557 420.855 72.0697C421.606 73.8837 421.802 75.8797 421.418 77.8051C421.035 79.7305 420.088 81.4988 418.699 82.8864C417.311 84.2739 415.541 85.2183 413.615 85.6001C411.69 85.9818 409.694 85.7838 407.881 85.0311C406.067 84.2784 404.518 83.0048 403.429 81.3714C402.34 79.7381 401.759 77.8183 401.761 75.855C401.764 73.2264 402.809 70.7063 404.668 68.8477C406.527 66.989 409.047 65.9436 411.675 65.9409H411.686Z",
    fill: "#DCEAF8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M393.347 125.66C395.238 125.263 397.037 124.512 398.65 123.447L400.945 125.354L405.025 121.274L403.128 118.98C404.188 117.365 404.935 115.566 405.331 113.676L408.289 113.39V107.648L405.331 107.372C404.937 105.481 404.19 103.682 403.128 102.068L405.025 99.7735L400.945 95.6936L398.65 97.5907C397.037 96.5292 395.237 95.7818 393.347 95.3876L393.071 92.4297H387.329L387.053 95.3876C385.163 95.7818 383.363 96.5292 381.75 97.5907L379.444 95.7344L375.365 99.8143L377.262 102.109C376.2 103.723 375.453 105.522 375.059 107.413L372.101 107.688V113.431L375.059 113.716C375.455 115.607 376.202 117.406 377.262 119.02L375.365 121.295L379.444 125.375L381.739 123.467C383.352 124.532 385.152 125.283 387.043 125.681L387.319 128.628H393.061L393.347 125.66ZM382.423 110.544C382.421 109.005 382.875 107.499 383.729 106.218C384.583 104.937 385.798 103.938 387.22 103.347C388.642 102.757 390.207 102.601 391.717 102.9C393.227 103.199 394.615 103.94 395.704 105.028C396.794 106.116 397.536 107.502 397.837 109.012C398.138 110.522 397.985 112.087 397.396 113.51C396.807 114.933 395.81 116.149 394.53 117.004C393.25 117.86 391.745 118.317 390.205 118.317C388.143 118.317 386.165 117.498 384.706 116.041C383.247 114.583 382.425 112.607 382.423 110.544Z",
    fill: "#DCEAF8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M380.535 94.5817L382.463 96.1728L385.88 92.7661L384.278 90.8384C385.173 89.483 385.803 87.9707 386.135 86.3811L388.613 86.1465V81.3323L386.135 81.0977C385.803 79.5081 385.173 77.9958 384.278 76.6404L385.88 74.7127L382.504 71.306L380.576 72.8971C379.223 72.0048 377.715 71.375 376.129 71.0408L375.894 68.5623H371.07L370.835 71.0408C369.246 71.3729 367.733 72.0027 366.378 72.8971L364.45 71.306L361.044 74.7127L362.635 76.6404C361.744 77.9964 361.117 79.5088 360.789 81.0977L358.3 81.3323V86.1465L360.789 86.3811C361.117 87.97 361.744 89.4824 362.635 90.8384L361.003 92.8171L364.409 96.2238L366.337 94.6327C367.691 95.5279 369.204 96.1547 370.794 96.4788L371.029 98.9676H375.854L376.088 96.4788C377.678 96.1371 379.188 95.493 380.535 94.5817ZM366.908 83.7394C366.908 82.4483 367.291 81.1863 368.009 80.1128C368.726 79.0393 369.745 78.2026 370.938 77.7085C372.131 77.2144 373.443 77.0851 374.71 77.337C375.976 77.5889 377.139 78.2106 378.052 79.1236C378.965 80.0365 379.587 81.1996 379.839 82.4659C380.09 83.7322 379.961 85.0447 379.467 86.2375C378.973 87.4303 378.136 88.4498 377.063 89.1671C375.989 89.8844 374.727 90.2672 373.436 90.2672C371.705 90.2672 370.045 89.5795 368.82 88.3553C367.596 87.1311 366.908 85.4707 366.908 83.7394Z",
    fill: "#DCEAF8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M448.179 274.402H379.688V318.944H448.179V274.402Z",
    fill: "#DCEAF8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M445.659 282.756H382.187V316.721H445.659V282.756Z",
    fill: "#DCEAF8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M434.318 287.835H387.358V289.294H434.318V287.835Z",
    fill: "#DCEAF8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M409.89 292.303H387.358V293.761H409.89V292.303Z",
    fill: "#DCEAF8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M415.734 296.781H387.358V298.239H415.734V296.781Z",
    fill: "#DCEAF8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M397.354 301.258H387.358V302.717H397.354V301.258Z",
    fill: "#DCEAF8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M393.835 305.736H387.358V307.194H393.835V305.736Z",
    fill: "#DCEAF8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M97.512 274.15L48.7783 274.371L48.9147 304.429L97.6484 304.208L97.512 274.15Z",
    fill: "#C9DDF1"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4752 296.872C67.2592 296.873 67.0485 296.805 66.8735 296.679L57.9895 290.181C57.861 290.087 57.7562 289.965 57.6836 289.823C57.611 289.681 57.5725 289.525 57.5713 289.365C57.5697 289.205 57.6058 289.047 57.6767 288.904C57.7476 288.76 57.8513 288.635 57.9793 288.539L66.8123 281.96C67.03 281.8 67.3028 281.732 67.5706 281.772C67.8384 281.812 68.0793 281.957 68.2402 282.175C68.4012 282.392 68.469 282.665 68.4289 282.933C68.3887 283.201 68.2438 283.442 68.026 283.603L60.3049 289.355L68.077 295.026C68.2519 295.153 68.3821 295.332 68.4488 295.537C68.5156 295.742 68.5155 295.963 68.4487 296.169C68.3818 296.374 68.2515 296.553 68.0766 296.679C67.9016 296.805 67.6911 296.873 67.4752 296.872Z",
    fill: "#FAFAFA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0215 296.811C78.8614 296.813 78.7032 296.777 78.5597 296.706C78.4161 296.635 78.2913 296.531 78.1953 296.403C78.1155 296.295 78.0577 296.173 78.0252 296.043C77.9928 295.913 77.9863 295.777 78.0062 295.645C78.0261 295.512 78.072 295.385 78.1412 295.27C78.2104 295.155 78.3015 295.055 78.4095 294.975L86.1306 289.223L78.3585 283.552C78.1407 283.391 77.9958 283.15 77.9556 282.882C77.9155 282.614 77.9833 282.341 78.1443 282.124C78.3052 281.906 78.5461 281.761 78.8139 281.721C79.0817 281.681 79.3545 281.748 79.5722 281.909L88.4562 288.396C88.5861 288.491 88.6917 288.616 88.7644 288.759C88.8371 288.903 88.8748 289.062 88.8744 289.223C88.8744 289.381 88.8375 289.537 88.7667 289.679C88.6959 289.82 88.5931 289.944 88.4664 290.039L79.6334 296.617C79.4556 296.746 79.241 296.814 79.0215 296.811Z",
    fill: "#FAFAFA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9223 296.862C70.8075 296.861 70.6937 296.84 70.5857 296.801C70.3321 296.711 70.1243 296.524 70.0078 296.281C69.8912 296.039 69.8753 295.76 69.9636 295.506L74.5432 282.409C74.5874 282.283 74.6561 282.166 74.7454 282.066C74.8347 281.966 74.9428 281.884 75.0635 281.826C75.1843 281.768 75.3153 281.734 75.4492 281.726C75.5831 281.719 75.7171 281.738 75.8437 281.782C75.9703 281.826 76.0869 281.895 76.1869 281.984C76.2869 282.073 76.3684 282.181 76.4267 282.302C76.4849 282.423 76.5188 282.554 76.5264 282.688C76.534 282.822 76.5152 282.956 76.471 283.082L71.8913 296.179C71.8211 296.379 71.69 296.553 71.5163 296.676C71.3426 296.798 71.1349 296.863 70.9223 296.862Z",
    fill: "#FAFAFA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M255.007 380C364.228 380 452.769 374.831 452.769 368.454C452.769 362.077 364.228 356.908 255.007 356.908C145.786 356.908 57.2451 362.077 57.2451 368.454C57.2451 374.831 145.786 380 255.007 380Z",
    fill: "#DCEAF8"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M341.073 368.454H348.57L358.77 312.111H351.273L341.073 368.454Z",
    fill: "#263238"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M341.073 368.454H348.57L358.77 312.111H351.273L341.073 368.454Z",
    fill: "#E3F4FA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M341.073 368.454H346.53L356.73 312.111H351.273L341.073 368.454Z",
    fill: "#E3F4FA"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M319.97 328.869H349.947C350.164 328.87 350.38 328.828 350.581 328.746C350.782 328.663 350.964 328.541 351.118 328.388C351.272 328.234 351.393 328.051 351.476 327.85C351.559 327.649 351.6 327.434 351.599 327.216C351.6 326.999 351.559 326.783 351.476 326.582C351.393 326.381 351.272 326.199 351.118 326.045C350.964 325.891 350.782 325.77 350.581 325.687C350.38 325.604 350.164 325.563 349.947 325.564H319.97C319.752 325.563 319.537 325.604 319.336 325.687C319.135 325.77 318.952 325.891 318.798 326.045C318.645 326.199 318.523 326.381 318.44 326.582C318.358 326.783 318.316 326.999 318.317 327.216C318.316 327.434 318.358 327.649 318.44 327.85C318.523 328.051 318.645 328.234 318.798 328.388C318.952 328.541 319.135 328.663 319.336 328.746C319.537 328.828 319.752 328.87 319.97 328.869Z",
    fill: "#263238"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M316.634 347.738H346.621C347.06 347.736 347.48 347.559 347.79 347.248C348.1 346.936 348.273 346.515 348.273 346.076C348.271 345.638 348.096 345.22 347.786 344.91C347.477 344.601 347.058 344.426 346.621 344.423H316.634C316.196 344.426 315.778 344.601 315.468 344.91C315.159 345.22 314.984 345.638 314.981 346.076C314.981 346.515 315.155 346.936 315.465 347.248C315.774 347.559 316.195 347.736 316.634 347.738Z",
    fill: "#263238"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M310.474 368.454H317.97L328.17 312.111H320.673L310.474 368.454Z",
    fill: "#263238"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M310.474 368.454H317.97L328.17 312.111H320.673L310.474 368.454Z",
    fill: "#E3F4FA"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M310.474 368.454H315.93L326.13 312.111H320.673L310.474 368.454Z",
    fill: "#E3F4FA"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M380.188 368.454H372.691L362.491 312.111H369.988L380.188 368.454Z",
    fill: "#263238"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M380.188 368.454H372.691L362.491 312.111H369.988L380.188 368.454Z",
    fill: "#E3F4FA"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M378.148 368.454H372.691L362.491 312.111H367.948L378.148 368.454Z",
    fill: "#E3F4FA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M367.021 328.869H337.034C336.596 328.869 336.176 328.695 335.866 328.385C335.556 328.075 335.382 327.655 335.382 327.216C335.382 326.778 335.556 326.358 335.866 326.048C336.176 325.738 336.596 325.564 337.034 325.564H367.021C367.46 325.564 367.88 325.738 368.19 326.048C368.5 326.358 368.674 326.778 368.674 327.216C368.674 327.655 368.5 328.075 368.19 328.385C367.88 328.695 367.46 328.869 367.021 328.869Z",
    fill: "#263238"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M370.345 347.738H340.368C340.15 347.738 339.935 347.695 339.734 347.611C339.532 347.528 339.35 347.405 339.196 347.251C339.043 347.096 338.921 346.913 338.839 346.711C338.756 346.509 338.715 346.294 338.716 346.076C338.716 345.637 338.89 345.217 339.2 344.907C339.51 344.597 339.93 344.423 340.368 344.423H370.345C370.783 344.423 371.204 344.597 371.514 344.907C371.823 345.217 371.997 345.637 371.997 346.076C371.999 346.294 371.957 346.509 371.875 346.711C371.792 346.913 371.671 347.096 371.517 347.251C371.364 347.405 371.181 347.528 370.98 347.611C370.779 347.695 370.563 347.738 370.345 347.738Z",
    fill: "#263238"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M367.021 328.869H337.034C336.596 328.869 336.176 328.695 335.866 328.385C335.556 328.075 335.382 327.655 335.382 327.216C335.382 326.778 335.556 326.358 335.866 326.048C336.176 325.738 336.596 325.564 337.034 325.564H367.021C367.46 325.564 367.88 325.738 368.19 326.048C368.5 326.358 368.674 326.778 368.674 327.216C368.674 327.655 368.5 328.075 368.19 328.385C367.88 328.695 367.46 328.869 367.021 328.869Z",
    fill: "#E3F4FA"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M370.345 347.738H340.368C340.15 347.738 339.935 347.695 339.734 347.611C339.532 347.528 339.35 347.405 339.196 347.251C339.043 347.096 338.921 346.913 338.839 346.711C338.756 346.509 338.715 346.294 338.716 346.076C338.716 345.637 338.89 345.217 339.2 344.907C339.51 344.597 339.93 344.423 340.368 344.423H370.345C370.783 344.423 371.204 344.597 371.514 344.907C371.823 345.217 371.997 345.637 371.997 346.076C371.999 346.294 371.957 346.509 371.875 346.711C371.792 346.913 371.671 347.096 371.517 347.251C371.364 347.405 371.181 347.528 370.98 347.611C370.779 347.695 370.563 347.738 370.345 347.738Z",
    fill: "#E3F4FA"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M349.59 368.454H342.093L331.894 312.111H339.39L349.59 368.454Z",
    fill: "#263238"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M349.59 368.454H342.093L331.894 312.111H339.39L349.59 368.454Z",
    fill: "#E3F4FA"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M347.55 368.454H342.093L331.894 312.111H337.35L347.55 368.454Z",
    fill: "#E3F4FA"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M372.906 309.418H318.756C318.085 309.418 317.542 309.961 317.542 310.632V313.579C317.542 314.25 318.085 314.793 318.756 314.793H372.906C373.576 314.793 374.12 314.25 374.12 313.579V310.632C374.12 309.961 373.576 309.418 372.906 309.418Z",
    fill: "#263238"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M339.339 309.418H318.756C318.085 309.418 317.542 309.961 317.542 310.632V313.579C317.542 314.25 318.085 314.793 318.756 314.793H339.339C340.009 314.793 340.553 314.25 340.553 313.579V310.632C340.553 309.961 340.009 309.418 339.339 309.418Z",
    fill: "#E3F4FA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M198.246 323.177H129.755V367.72H198.246V323.177Z",
    fill: "url(#paint0_linear_484_5341)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M198.246 323.177H129.755V367.72H198.246V323.177Z",
    fill: "#E3F4FA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M195.748 331.531H132.265V365.496H195.748V331.531Z",
    fill: "url(#paint1_linear_484_5341)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M184.394 336.6H137.435V338.059H184.394V336.6Z",
    fill: "#E3F4FA"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M159.966 341.078H137.435V342.536H159.966V341.078Z",
    fill: "#E3F4FA"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M165.81 345.556H137.435V347.014H165.81V345.556Z",
    fill: "#E3F4FA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M147.43 350.023H137.435V351.482H147.43V350.023Z",
    fill: "#E3F4FA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M143.911 354.501H137.435V355.959H143.911V354.501Z",
    fill: "#E3F4FA"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M282.883 368.454H227.132L236.567 294.333H273.449L282.883 368.454Z",
    fill: "url(#paint2_linear_484_5341)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M282.883 368.454H227.132L233.588 317.741L236.577 294.333H273.438L277.845 328.869L282.883 368.454Z",
    fill: "#E3F4FA"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M277.845 328.869L233.589 317.741L236.577 294.333H273.439L277.845 328.869Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M386.451 111.564H123.564C122.681 111.564 121.806 111.738 120.99 112.077C120.174 112.415 119.432 112.911 118.808 113.537C118.184 114.162 117.689 114.904 117.351 115.721C117.014 116.537 116.841 117.412 116.843 118.296V296.26C116.843 298.043 117.551 299.753 118.811 301.013C120.072 302.274 121.782 302.982 123.564 302.982H386.451C388.234 302.982 389.944 302.274 391.204 301.013C392.465 299.753 393.173 298.043 393.173 296.26V118.316C393.177 117.431 393.006 116.554 392.67 115.735C392.334 114.916 391.84 114.171 391.215 113.544C390.591 112.916 389.848 112.418 389.031 112.079C388.213 111.739 387.337 111.564 386.451 111.564Z",
    fill: "url(#paint3_linear_484_5341)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M386.451 111.564H123.564C122.681 111.564 121.806 111.738 120.99 112.077C120.174 112.415 119.432 112.911 118.808 113.537C118.184 114.162 117.689 114.904 117.351 115.721C117.014 116.537 116.841 117.412 116.843 118.296V296.26C116.843 298.043 117.551 299.753 118.811 301.013C120.072 302.274 121.782 302.982 123.564 302.982H386.451C388.234 302.982 389.944 302.274 391.204 301.013C392.465 299.753 393.173 298.043 393.173 296.26V118.316C393.177 117.431 393.006 116.554 392.67 115.735C392.334 114.916 391.84 114.171 391.215 113.544C390.591 112.916 389.848 112.418 389.031 112.079C388.213 111.739 387.337 111.564 386.451 111.564Z",
    fill: "#E3F4FA"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M384.33 118.153H125.696V289.763H384.33V118.153Z",
    fill: "url(#paint4_linear_484_5341)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M301.824 362.885H208.181C207.595 362.885 207.12 363.36 207.12 363.946V367.301C207.12 367.887 207.595 368.362 208.181 368.362H301.824C302.41 368.362 302.885 367.887 302.885 367.301V363.946C302.885 363.36 302.41 362.885 301.824 362.885Z",
    fill: "url(#paint5_linear_484_5341)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M301.824 362.885H208.181C207.595 362.885 207.12 363.36 207.12 363.946V367.301C207.12 367.887 207.595 368.362 208.181 368.362H301.824C302.41 368.362 302.885 367.887 302.885 367.301V363.946C302.885 363.36 302.41 362.885 301.824 362.885Z",
    fill: "#E3F4FA"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M384.33 118.316H125.696V143.897H384.33V118.316Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M236.526 144.203H125.696V289.763H236.526V144.203Z",
    fill: "#E3F4FA"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M344.522 181.33V183.88H341.972",
    stroke: "#E3F4FA",
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M336.585 183.88H253.05",
    stroke: "#E3F4FA",
    strokeMiterlimit: 10,
    strokeDasharray: "5.28 5.28"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M250.358 183.88H247.808V181.33",
    stroke: "#E3F4FA",
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M247.808 176.71V132.821",
    stroke: "#E3F4FA",
    strokeMiterlimit: 10,
    strokeDasharray: "4.53 4.53"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M247.808 130.515V127.965H250.358",
    stroke: "#E3F4FA",
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M255.743 127.965H339.279",
    stroke: "#E3F4FA",
    strokeMiterlimit: 10,
    strokeDasharray: "5.28 5.28"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M341.972 127.965H344.522V130.515",
    stroke: "#E3F4FA",
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M344.521 135.136V179.025",
    stroke: "#E3F4FA",
    strokeMiterlimit: 10,
    strokeDasharray: "4.53 4.53"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M346.142 126.344H342.909V129.577H346.142V126.344Z",
    fill: "url(#paint6_linear_484_5341)",
    stroke: "#E3F4FA",
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M346.142 182.269H342.909V185.502H346.142V182.269Z",
    fill: "url(#paint7_linear_484_5341)",
    stroke: "#E3F4FA",
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M249.418 126.344H246.185V129.577H249.418V126.344Z",
    fill: "url(#paint8_linear_484_5341)",
    stroke: "#E3F4FA",
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M249.418 182.269H246.185V185.502H249.418V182.269Z",
    fill: "url(#paint9_linear_484_5341)",
    stroke: "#E3F4FA",
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M297.785 126.344H294.552V129.577H297.785V126.344Z",
    fill: "url(#paint10_linear_484_5341)",
    stroke: "#E3F4FA",
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M297.785 182.269H294.552V185.502H297.785V182.269Z",
    fill: "url(#paint11_linear_484_5341)",
    stroke: "#E3F4FA",
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M346.142 154.301H342.909V157.534H346.142V154.301Z",
    fill: "url(#paint12_linear_484_5341)",
    stroke: "#E3F4FA",
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M249.418 154.301H246.185V157.534H249.418V154.301Z",
    fill: "url(#paint13_linear_484_5341)",
    stroke: "#E3F4FA",
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M335.739 146.743H312.065C311.001 146.743 310.138 147.606 310.138 148.671V155.005C310.138 156.07 311.001 156.933 312.065 156.933H335.739C336.804 156.933 337.667 156.07 337.667 155.005V148.671C337.667 147.606 336.804 146.743 335.739 146.743Z",
    fill: "#E3F4FA"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M294.94 146.743H271.267C270.202 146.743 269.339 147.606 269.339 148.671V155.005C269.339 156.07 270.202 156.933 271.267 156.933H294.94C296.005 156.933 296.868 156.07 296.868 155.005V148.671C296.868 147.606 296.005 146.743 294.94 146.743Z",
    fill: "#E3F4FA"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M242.423 270.761H218.749C217.684 270.761 216.821 271.624 216.821 272.689V279.023C216.821 280.088 217.684 280.951 218.749 280.951H242.423C243.487 280.951 244.35 280.088 244.35 279.023V272.689C244.35 271.624 243.487 270.761 242.423 270.761Z",
    fill: "#E3F4FA"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M367.255 127.415H375.863",
    stroke: "#E3F4FA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M367.255 131.495H375.863",
    stroke: "#E3F4FA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M367.255 135.574H375.863",
    stroke: "#E3F4FA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M229.978 166.765H143.229V253.514H229.978V166.765Z",
    fill: "#E3F4FA"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M179.54 173.854V248.689",
    stroke: "url(#paint14_linear_484_5341)",
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M216.953 248.689C207.028 248.689 197.509 244.746 190.491 237.728C183.473 230.71 179.53 221.191 179.53 211.266C179.53 201.344 183.472 191.828 190.488 184.812C197.504 177.795 207.02 173.854 216.943 173.854",
    stroke: "url(#paint15_linear_484_5341)",
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M218.574 172.242H215.341V175.476H218.574V172.242Z",
    fill: "#E3F4FA",
    stroke: "url(#paint16_linear_484_5341)",
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M218.574 247.067H215.341V250.301H218.574V247.067Z",
    fill: "#E3F4FA",
    stroke: "url(#paint17_linear_484_5341)",
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M181.162 209.655H177.929V212.888H181.162V209.655Z",
    fill: "#E3F4FA",
    stroke: "url(#paint18_linear_484_5341)",
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M180.377 173.854C180.377 174.019 180.328 174.181 180.236 174.319C180.144 174.456 180.013 174.563 179.861 174.627C179.708 174.69 179.54 174.707 179.377 174.674C179.215 174.642 179.066 174.562 178.949 174.445C178.832 174.328 178.752 174.179 178.72 174.017C178.688 173.855 178.704 173.687 178.768 173.534C178.831 173.381 178.938 173.25 179.076 173.159C179.213 173.067 179.375 173.018 179.54 173.018C179.761 173.02 179.973 173.109 180.129 173.265C180.285 173.422 180.374 173.633 180.377 173.854Z",
    fill: "#E3F4FA",
    stroke: "url(#paint19_linear_484_5341)",
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M180.377 248.689C180.377 248.854 180.328 249.015 180.237 249.153C180.145 249.29 180.015 249.397 179.863 249.461C179.711 249.524 179.543 249.541 179.381 249.51C179.219 249.479 179.07 249.4 178.953 249.284C178.835 249.168 178.755 249.02 178.721 248.858C178.688 248.697 178.703 248.529 178.765 248.376C178.827 248.223 178.932 248.092 179.068 247.998C179.205 247.905 179.365 247.855 179.53 247.853C179.641 247.851 179.751 247.872 179.853 247.913C179.956 247.955 180.05 248.016 180.128 248.094C180.207 248.172 180.27 248.264 180.312 248.367C180.355 248.469 180.377 248.578 180.377 248.689Z",
    fill: "#E3F4FA",
    stroke: "url(#paint20_linear_484_5341)",
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M323.274 271.995H297.009C294.997 271.995 293.067 271.196 291.644 269.773C290.22 268.349 289.421 266.419 289.421 264.407C289.421 262.394 290.22 260.464 291.644 259.041C293.067 257.618 294.997 256.818 297.009 256.818H323.274C325.286 256.818 327.217 257.618 328.64 259.041C330.063 260.464 330.862 262.394 330.862 264.407C330.862 266.419 330.063 268.349 328.64 269.773C327.217 271.196 325.286 271.995 323.274 271.995Z",
    fill: "#E3F4FA"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M346.347 207.278H265.208C264.768 207.278 264.345 207.103 264.033 206.791C263.721 206.479 263.546 206.057 263.546 205.616C263.554 205.181 263.733 204.767 264.044 204.463C264.355 204.16 264.774 203.991 265.208 203.994H346.337C346.555 203.993 346.771 204.034 346.972 204.117C347.174 204.199 347.357 204.321 347.512 204.474C347.666 204.628 347.789 204.81 347.873 205.012C347.956 205.213 347.999 205.428 347.999 205.646C347.991 206.08 347.814 206.494 347.505 206.799C347.197 207.104 346.781 207.276 346.347 207.278Z",
    fill: "#E3F4FA"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M346.347 219.385H265.208C264.991 219.387 264.775 219.345 264.573 219.262C264.371 219.18 264.188 219.058 264.033 218.905C263.879 218.751 263.756 218.569 263.673 218.368C263.589 218.166 263.546 217.951 263.546 217.733C263.546 217.292 263.721 216.869 264.033 216.557C264.345 216.245 264.768 216.07 265.208 216.07H346.337C346.778 216.07 347.201 216.245 347.512 216.557C347.824 216.869 347.999 217.292 347.999 217.733C347.999 218.171 347.825 218.591 347.515 218.901C347.206 219.211 346.785 219.385 346.347 219.385Z",
    fill: "#E3F4FA"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M346.346 231.533H295.806C295.367 231.533 294.946 231.359 294.634 231.05C294.323 230.74 294.146 230.32 294.144 229.881C294.144 229.44 294.319 229.017 294.631 228.705C294.942 228.393 295.365 228.218 295.806 228.218H346.335C346.776 228.218 347.199 228.393 347.511 228.705C347.823 229.017 347.998 229.44 347.998 229.881C347.995 230.318 347.82 230.737 347.511 231.046C347.202 231.356 346.783 231.53 346.346 231.533Z",
    fill: "#E3F4FA"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M139.598 125.405H133.866V131.138H139.598V125.405Z",
    fill: "black"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M149.268 125.405H146.474C145.662 125.405 145.005 126.063 145.005 126.874V129.669C145.005 130.48 145.662 131.138 146.474 131.138H149.268C150.08 131.138 150.737 130.48 150.737 129.669V126.874C150.737 126.063 150.08 125.405 149.268 125.405Z",
    fill: "black"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M159.264 125.405H158.775C157.327 125.405 156.153 126.579 156.153 128.027V128.516C156.153 129.964 157.327 131.138 158.775 131.138H159.264C160.712 131.138 161.886 129.964 161.886 128.516V128.027C161.886 126.579 160.712 125.405 159.264 125.405Z",
    fill: "black"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M151.431 266.722V264.488L150.289 264.386C150.125 263.661 149.835 262.971 149.432 262.346L150.166 261.459L148.585 259.878L147.698 260.612C147.074 260.209 146.383 259.919 145.658 259.756L145.556 258.613H143.322L143.21 259.756C142.485 259.92 141.795 260.21 141.17 260.612L140.283 259.878L138.702 261.459L139.436 262.346C139.024 262.966 138.734 263.658 138.579 264.386L137.427 264.488V266.722L138.579 266.834C138.734 267.562 139.025 268.254 139.436 268.874L138.702 269.772L140.283 271.343L141.17 270.608C141.79 271.019 142.482 271.31 143.21 271.465L143.322 272.617H145.556L145.658 271.465C146.386 271.311 147.078 271.02 147.698 270.608L148.585 271.343L150.166 269.772L149.432 268.874C149.839 268.252 150.129 267.561 150.289 266.834L151.431 266.722ZM144.403 268.629C143.798 268.629 143.207 268.45 142.703 268.114C142.2 267.777 141.808 267.3 141.576 266.74C141.345 266.181 141.284 265.566 141.402 264.973C141.52 264.379 141.812 263.834 142.24 263.406C142.668 262.978 143.213 262.686 143.806 262.568C144.4 262.45 145.015 262.511 145.574 262.742C146.133 262.974 146.611 263.366 146.948 263.869C147.284 264.373 147.463 264.964 147.463 265.569C147.463 266.381 147.141 267.159 146.567 267.733C145.993 268.307 145.215 268.629 144.403 268.629Z",
    fill: "#E3F4FA"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M160.487 273.026V271.312L159.59 271.22C159.468 270.646 159.24 270.099 158.917 269.609L159.488 268.905L158.254 267.671L157.56 268.252C157.066 267.929 156.516 267.701 155.938 267.579L155.857 266.671H154.102L154.021 267.579C153.443 267.701 152.893 267.929 152.399 268.252L151.705 267.671L150.461 268.905L151.042 269.609C150.719 270.099 150.491 270.646 150.369 271.22L149.472 271.312V273.056L150.369 273.148C150.491 273.722 150.719 274.269 151.042 274.759L150.461 275.463L151.705 276.697L152.399 276.116C152.893 276.439 153.443 276.668 154.021 276.789L154.102 277.687H155.857L155.938 276.789C156.516 276.668 157.066 276.439 157.56 276.116L158.254 276.697L159.488 275.463L158.917 274.759C159.24 274.269 159.468 273.722 159.59 273.148L160.487 273.026ZM154.98 274.525C154.509 274.527 154.049 274.389 153.656 274.129C153.264 273.869 152.958 273.499 152.777 273.065C152.595 272.631 152.547 272.153 152.637 271.691C152.728 271.229 152.953 270.805 153.285 270.472C153.617 270.138 154.041 269.911 154.502 269.818C154.963 269.726 155.442 269.772 155.876 269.952C156.311 270.131 156.683 270.436 156.945 270.827C157.206 271.218 157.346 271.678 157.346 272.148C157.347 272.46 157.287 272.769 157.169 273.057C157.05 273.345 156.876 273.607 156.656 273.828C156.437 274.049 156.175 274.224 155.887 274.344C155.6 274.463 155.291 274.525 154.98 274.525Z",
    fill: "#E3F4FA"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M151.431 277.993V276.524L150.676 276.453C150.575 275.97 150.385 275.51 150.115 275.096L150.605 274.515L149.585 273.495L148.993 273.974C148.58 273.705 148.12 273.514 147.637 273.413L147.565 272.658H146.076L146.005 273.413C145.522 273.514 145.062 273.705 144.648 273.974L144.057 273.495L143.037 274.515L143.526 275.096C143.257 275.51 143.066 275.97 142.965 276.453L142.2 276.524V277.993L142.965 278.064C143.064 278.551 143.255 279.015 143.526 279.431L143.037 280.012L144.057 281.032L144.648 280.543C145.059 280.82 145.52 281.014 146.005 281.114L146.076 281.869H147.545L147.616 281.114C148.101 281.014 148.562 280.82 148.973 280.543L149.564 281.032L150.584 280.012L150.095 279.431C150.366 279.015 150.556 278.551 150.656 278.064L151.431 277.993ZM146.81 279.247C146.419 279.237 146.04 279.112 145.72 278.888C145.399 278.663 145.152 278.349 145.01 277.985C144.867 277.621 144.835 277.223 144.917 276.84C145 276.458 145.193 276.108 145.473 275.835C145.753 275.562 146.107 275.378 146.492 275.305C146.876 275.232 147.273 275.274 147.634 275.426C147.994 275.578 148.302 275.833 148.518 276.159C148.735 276.485 148.85 276.867 148.85 277.258C148.85 277.524 148.797 277.787 148.694 278.032C148.591 278.276 148.44 278.498 148.25 278.683C148.06 278.869 147.834 279.014 147.587 279.111C147.34 279.208 147.076 279.254 146.81 279.247Z",
    fill: "#E3F4FA"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M343.929 127.384L348.253 138.95L355.485 131.709L343.929 127.384Z",
    fill: "url(#paint21_linear_484_5341)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M350.894 132.732L349.278 134.348L352.863 137.932L354.478 136.317L350.894 132.732Z",
    fill: "url(#paint22_linear_484_5341)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M355.485 131.709L343.929 127.384L348.253 138.95L351.069 136.135L352.853 137.931L354.465 136.319L352.68 134.524L355.485 131.709Z",
    fill: "#E3F4FA"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M166.739 168.723L177.622 172.803L171.921 167.102C171.71 167.223 171.465 167.272 171.223 167.24C170.982 167.209 170.758 167.099 170.585 166.928C170.374 166.717 170.255 166.431 170.255 166.133C170.255 165.834 170.374 165.548 170.585 165.337C170.796 165.126 171.082 165.008 171.38 165.008C171.679 165.008 171.965 165.126 172.176 165.337C172.347 165.51 172.457 165.735 172.488 165.976C172.519 166.217 172.47 166.462 172.349 166.673L178.051 172.375L173.971 161.492L170.36 162.287L170.228 160.992L169.544 160.309L165.546 164.307L166.229 164.99L167.535 165.123L166.739 168.723Z",
    fill: "#263238"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M166.739 168.723L177.622 172.803L171.921 167.102C171.71 167.223 171.465 167.272 171.223 167.24C170.982 167.209 170.758 167.099 170.585 166.928C170.374 166.717 170.255 166.431 170.255 166.133C170.255 165.834 170.374 165.548 170.585 165.337C170.796 165.126 171.082 165.008 171.38 165.008C171.679 165.008 171.965 165.126 172.176 165.337C172.347 165.51 172.457 165.735 172.488 165.976C172.519 166.217 172.47 166.462 172.349 166.673L178.051 172.375L173.971 161.492L170.36 162.287L170.228 160.992L169.544 160.309L165.546 164.307L166.229 164.99L167.535 165.123L166.739 168.723Z",
    fill: "#E3F4FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.517 118.153L125.187 261.378V118.153H163.517Z",
    fill: "#E3F4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.773 118.153L160.844 289.763H129.204L175.123 118.153H206.773Z",
    fill: "#E3F4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.774 118.153L206.844 289.763H192.534L238.463 118.153H252.774Z",
    fill: "#E3F4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.134 118.153L249.205 289.763H244.085L290.014 118.153H295.134Z",
    fill: "#E3F4FA"
  }))), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M450.739 156.055C454.36 160.227 472.78 195.711 469.221 203.994C465.661 212.276 436.143 202.729 436.143 202.729L437.908 191.03C437.908 191.03 449.372 191.438 450.474 190.346C451.575 189.255 434.96 172.67 434.96 172.67L450.739 156.055Z",
    fill: "#263238"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.201 203.994C468.764 204.952 468.001 205.725 467.049 206.176L466.457 206.441H466.376C466.193 206.518 466.006 206.583 465.815 206.635C464.986 206.901 464.131 207.079 463.265 207.166L462.52 207.237C462.153 207.237 461.786 207.288 461.409 207.298H460.389C450.495 207.298 436.103 202.657 436.103 202.657L437.868 190.958C437.868 190.958 449.332 191.366 450.434 190.275C450.699 190.01 449.914 188.827 448.577 187.215C445.334 183.227 438.837 176.587 436.154 173.874L434.94 172.65L450.74 156.055C454.361 160.186 472.781 195.671 469.201 203.994Z",
    fill: "#E3F4FA"
  }))), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M467.07 206.146L466.478 206.411H466.397C466.214 206.488 466.027 206.552 465.836 206.605C465.007 206.871 464.152 207.048 463.286 207.135L462.541 207.206C462.174 207.206 461.807 207.257 461.429 207.268H460.41C450.516 207.268 436.124 202.627 436.124 202.627L437.889 190.928C437.889 190.928 450.801 192.019 451.903 190.928C452.107 190.499 450.679 189.051 448.568 187.205C445.324 183.217 438.827 176.577 436.144 173.864L443.611 165.887L449.292 165.275C449.292 165.275 461.868 185.634 467.07 206.146Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M413.521 154.852C411.481 156.331 410.461 158.432 411.277 159.544L465.172 233.848C465.978 234.96 468.293 234.654 470.333 233.175C472.373 231.696 473.393 229.585 472.577 228.483L418.682 154.168C417.876 153.067 415.571 153.362 413.521 154.852Z",
    fill: "#263238"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M418.681 154.168L472.576 228.473C473.382 229.574 472.372 231.675 470.332 233.165C468.292 234.654 465.977 234.939 465.182 233.838L411.286 159.523C411.08 159.135 410.989 158.698 411.024 158.26C411.058 157.823 411.216 157.405 411.48 157.054C411.755 156.563 412.099 156.113 412.5 155.718C412.813 155.395 413.154 155.102 413.52 154.841C415.57 153.372 417.875 153.066 418.681 154.168Z",
    fill: "#E3F4FA"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M472.578 228.473C473.383 229.574 472.374 231.676 470.334 233.165C468.294 234.654 465.978 234.939 465.183 233.838C464.734 233.226 465.846 232.298 466.499 230.962L411.481 157.075C411.757 156.584 412.1 156.134 412.501 155.739L466.407 230.054C466.723 229.732 467.064 229.435 467.427 229.166C469.467 227.677 471.772 227.371 472.578 228.473Z",
    fill: "black"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M406.85 152.791C405.126 154.627 404.535 156.871 405.534 157.819L472.546 220.558C473.566 221.496 475.759 220.762 477.483 218.916C479.207 217.07 479.798 214.836 478.799 213.877L411.787 151.139C410.787 150.211 408.574 150.955 406.85 152.791Z",
    fill: "url(#paint23_linear_484_5341)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M411.786 151.149L478.798 213.887C479.818 214.815 479.206 217.07 477.482 218.916C475.759 220.762 473.545 221.486 472.546 220.558L405.534 157.82C405.26 157.476 405.089 157.062 405.041 156.625C404.992 156.188 405.067 155.747 405.258 155.351C405.441 154.817 405.695 154.309 406.013 153.842C406.265 153.481 406.545 153.14 406.849 152.822C408.573 150.955 410.787 150.211 411.786 151.149Z",
    fill: "#E3F4FA"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M478.799 213.888C479.819 214.816 479.207 217.07 477.483 218.916C475.759 220.762 473.546 221.486 472.546 220.558C471.995 220.038 472.913 218.926 473.301 217.498L405.259 155.372C405.442 154.837 405.696 154.33 406.014 153.862L473.036 216.611C473.282 216.248 473.559 215.907 473.862 215.591C475.586 213.684 477.799 212.949 478.799 213.888Z",
    fill: "black"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M422.955 353.011L417.856 353.093C412.664 328.706 408.992 298.525 406.707 275.759C406.35 272.189 406.024 268.813 405.687 265.661C405.555 264.162 405.422 262.724 405.3 261.336C404.688 254.492 404.28 249.097 404.015 245.711C403.831 243.263 403.739 241.916 403.739 241.916H422.282L422.109 246.618L421.497 262.132L421.436 263.907L421.048 274.158L420.406 291.609C426.74 316.19 422.955 353.011 422.955 353.011Z",
    fill: "#EBB376"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M464.366 351.706L459.337 352.654C449.27 327.492 439.815 295.271 433.664 272.76C432.716 269.272 431.839 266.008 431.053 263.05C431.053 262.897 430.982 262.754 430.941 262.611C429.391 256.736 428.197 252.055 427.453 249.086L426.565 245.486L444.721 242.344L445.741 249.994L447.261 261.214L447.556 263.417L448.576 271.077L451.34 291.619C461.826 314.773 464.366 351.706 464.366 351.706Z",
    fill: "#EBB376"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M447.313 261.234L431.055 263.05C431.055 262.897 430.983 262.754 430.942 262.611C429.392 256.736 428.199 252.055 427.454 249.086L445.814 249.994L447.313 261.234Z",
    fill: "black"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M422.068 246.618L421.497 262.132L421.436 263.907L405.728 265.651C405.596 264.152 405.463 262.714 405.341 261.326C404.729 254.482 404.321 249.087 404.056 245.7L422.068 246.618Z",
    fill: "black"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M407.87 369.963C408.82 369.192 409.902 368.598 411.063 368.209C411.063 368.209 414.541 364.762 416.224 354.378L420.773 353.185C421.546 353 422.357 353.057 423.097 353.347C423.838 353.637 424.471 354.146 424.914 354.807C425.039 354.991 425.136 355.194 425.199 355.408C425.435 356.522 425.598 357.65 425.689 358.785C425.944 362.581 425.967 366.389 425.76 370.188H424.934L424.608 363.048C424.485 360.61 422.619 363.466 422.089 366.108C421.558 368.75 420.426 371.504 415.102 371.636C408.88 371.728 406.299 371.483 407.87 369.963Z",
    fill: "#263238"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M425.077 354.949C425.373 352.521 425.465 348.299 425.465 348.299L415.347 349.421C415.347 349.421 416.571 354.225 415.561 357.836C420.661 356.438 425.077 354.949 425.077 354.949Z",
    fill: "#263238"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M449.036 369.963C449.987 369.195 451.068 368.605 452.228 368.219C452.228 368.219 455.707 364.772 457.379 354.389L461.939 353.195C462.712 353.011 463.523 353.067 464.263 353.357C465.003 353.647 465.637 354.156 466.08 354.817C466.205 355.002 466.302 355.205 466.365 355.419C466.6 356.532 466.764 357.66 466.855 358.795C467.108 362.591 467.128 366.399 466.916 370.198H466.141L465.814 363.058C465.692 360.621 463.826 363.476 463.295 366.118C462.765 368.76 461.633 371.514 456.298 371.646C450.046 371.728 447.465 371.483 449.036 369.963Z",
    fill: "#263238"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M466.233 354.949C466.539 352.521 466.631 348.299 466.631 348.299L456.513 349.421C456.513 349.421 457.737 354.225 456.727 357.836C461.827 356.438 466.233 354.949 466.233 354.949Z",
    fill: "#263238"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M449.068 256.226L429.821 258.684L429.076 258.776L425.119 244.272L424.099 259.816L403.475 258.735C394.295 204.81 409.993 192.07 409.993 192.07L437.97 197.7C450.638 219.242 447.63 244.272 447.63 244.272L449.068 256.226Z",
    fill: "url(#paint24_linear_484_5341)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M422.568 124.885C422.568 127.006 421.629 128.72 420.528 128.72C419.426 128.72 418.427 127.006 418.427 124.885C418.427 122.763 419.365 121.05 420.528 121.05C421.691 121.05 422.568 122.763 422.568 124.885Z",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M436.388 137.695C436.313 137.765 436.231 137.827 436.143 137.879C434.98 138.766 433.652 139.415 432.237 139.786C428.106 140.745 425.281 140.174 423.434 138.307C420.854 135.502 420.211 130.535 420.579 124.538C420.643 122.151 421.083 119.79 421.884 117.541C421.884 117.541 421.884 117.449 421.884 117.429C421.884 117.408 421.945 117.255 421.986 117.174C422.492 115.905 423.308 114.784 424.359 113.912C425.41 113.041 426.664 112.447 428.004 112.186C429.166 111.926 430.353 111.793 431.543 111.788C443.242 111.696 445.343 131.055 436.388 137.695Z",
    fill: "#EBB376"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M436.143 137.91C434.97 138.746 433.642 139.339 432.237 139.654C428.106 140.613 425.281 139.909 423.435 138.012C425.907 138.623 428.511 138.408 430.85 137.4C431.714 137.081 432.638 136.961 433.555 137.05C434.471 137.138 435.356 137.432 436.143 137.91Z",
    fill: "black"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M437.328 148.466C438.052 151.791 433.737 153.148 433.737 153.148C426.689 150.088 425.384 146.386 425.384 146.386C431.269 143.326 429.566 134.646 429.566 134.646L430.759 135.237L439.153 136.879C439.153 136.879 436.828 141.347 436.522 142.367C434.931 147.722 437.328 148.466 437.328 148.466Z",
    fill: "#EBB376"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M421.875 117.49C421.875 117.49 421.233 125.65 429.015 129.209C429.015 129.209 432.35 137.726 437.256 137.838C443.958 138.001 449.853 128.485 447.538 118.785C444.508 106.199 425.445 105.179 421.875 117.49Z",
    fill: "#263238"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M425.056 126.853C425.056 125.578 426.076 123.426 428.116 123.722C430.156 124.018 431.318 129.097 426.259 130.229C425.494 130.393 425.056 129.536 425.056 126.853Z",
    fill: "#EBB376"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M436.143 108.779C436.143 108.779 428.33 106.8 424.005 109.952C418.956 113.624 417.039 117.418 422.985 123.314C422.985 123.314 436.112 119.06 440.478 119.958C443.029 120.473 445.534 121.199 447.964 122.131C448.913 113.461 440.508 107.004 436.143 108.779Z",
    fill: "#263238"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M425.056 124.885C425.056 124.885 427.096 134.33 423.894 142.387C423.894 142.387 442.457 148.823 448.913 145.325C455.37 141.826 449.454 130.087 449.179 123.314C448.903 116.541 445.966 106.535 436.143 108.779C426.321 111.023 425.056 124.885 425.056 124.885Z",
    fill: "#263238"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M418.376 124.283H426.22",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M429.82 258.684L429.076 258.776L425.118 244.272C425.118 244.272 433.604 229.778 430.952 222.231C431.33 222.761 440.469 236.316 429.82 258.684Z",
    fill: "black"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M413.928 147.732C413.928 147.732 423.261 144.407 437.326 148.466C451.392 152.526 451.922 158.513 451.922 158.513C451.922 158.513 443.007 178.719 441.6 201.597L404.942 200.23C404.942 200.23 400.566 167.938 413.928 147.732Z",
    fill: "#263238"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M451.923 158.513C451.923 158.513 443.009 178.719 441.601 201.597L404.943 200.23C404.505 196.506 404.281 192.76 404.27 189.01C404.198 183.522 404.539 178.036 405.29 172.599C406.514 164.133 409.033 155.096 413.929 147.691C413.929 147.691 423.262 144.366 437.327 148.426C451.393 152.485 451.923 158.513 451.923 158.513Z",
    fill: "#E3F4FA"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M413.419 174.017C413.419 174.017 411.899 183.319 404.239 189.051C404.167 183.563 404.508 178.077 405.259 172.64L413.419 174.017Z",
    fill: "black"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M372.916 147.089L368.295 140.235C368.295 140.235 367.591 137.257 366.694 136.584C365.796 135.911 356.923 132.126 355.852 132.147C354.781 132.167 354.832 139.062 355.852 140.235C356.872 141.408 362.522 143.917 364.011 144.172C365.501 144.427 364.766 144.172 364.766 144.172L368.846 152.332L372.916 147.089Z",
    fill: "#EBB376"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M413.93 147.732C404.031 151.877 394.481 156.809 385.37 162.481L370.448 142.081C370.448 142.081 366.43 143.326 364.94 150.323C364.94 150.323 372.6 179.504 382.555 182.401C392.51 185.297 413.44 173.966 413.44 173.966C413.44 173.966 419.499 158.809 413.93 147.732Z",
    fill: "#263238"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M413.93 147.732C404.031 151.877 394.481 156.809 385.37 162.481L370.448 142.081C370.448 142.081 366.43 143.326 364.94 150.323C364.94 150.323 372.6 179.504 382.555 182.401C392.51 185.297 413.44 173.966 413.44 173.966C413.44 173.966 419.499 158.809 413.93 147.732Z",
    fill: "#E3F4FA"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M423.364 146.447C423.364 146.447 426.618 169.743 436.93 170.681C447.242 171.62 451.862 154.362 450.118 152.322C448.374 150.282 435.084 146.294 423.364 146.447Z",
    fill: "#263238"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M423.364 146.447C423.364 146.447 426.618 169.743 436.93 170.681C447.242 171.62 451.862 154.362 450.118 152.322C448.374 150.282 435.084 146.294 423.364 146.447Z",
    fill: "#E3F4FA"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4795 360.733H64.0375L64.6597 343.23H57.1017L56.4795 360.733Z",
    fill: "#B97964"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0785 359.856H55.8987C55.7475 359.853 55.6002 359.904 55.4827 359.999C55.3651 360.094 55.2849 360.227 55.2562 360.376L53.767 367.097C53.7356 367.241 53.7328 367.389 53.759 367.533C53.7851 367.678 53.8395 367.816 53.9192 367.939C53.9988 368.062 54.1021 368.168 54.223 368.252C54.344 368.335 54.4802 368.393 54.6238 368.423H54.8686C57.8367 368.372 59.9684 368.189 63.7219 368.189C66.027 368.189 72.9016 368.434 76.1247 368.434C79.3478 368.434 79.7048 365.302 78.4095 365.017C72.5854 363.742 68.2098 361.957 66.3432 360.315C65.9949 360.007 65.5429 359.843 65.0785 359.856Z",
    fill: "#263238"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5974 360.906C65.5627 360.896 65.5317 360.877 65.5081 360.85C65.4845 360.822 65.4694 360.789 65.4648 360.753C65.4584 360.719 65.4628 360.684 65.4774 360.653C65.4921 360.622 65.5162 360.596 65.5464 360.58C65.8218 360.406 68.2595 358.907 69.0959 359.335C69.1903 359.379 69.2697 359.45 69.3242 359.539C69.3786 359.628 69.4056 359.731 69.4019 359.835C69.4297 360.014 69.4095 360.197 69.3431 360.366C69.2768 360.534 69.1668 360.682 69.0245 360.794C68.6022 361.089 68.0894 361.227 67.5761 361.182C66.9086 361.161 66.2452 361.068 65.5974 360.906ZM66.1176 360.651C66.9995 360.95 67.962 360.903 68.8103 360.519C68.8986 360.439 68.9661 360.338 69.007 360.226C69.0478 360.114 69.0608 359.994 69.0449 359.876C69.0449 359.733 68.9837 359.662 68.9327 359.662C68.8602 359.625 68.7794 359.607 68.6981 359.611C67.7798 359.791 66.9042 360.144 66.1176 360.651Z",
    fill: "url(#paint25_linear_484_5341)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5477 360.937C65.5211 360.919 65.4995 360.895 65.4852 360.866C65.4709 360.837 65.4643 360.806 65.4661 360.774C65.4661 360.672 65.6599 358.499 66.4861 357.785C66.5874 357.694 66.7076 357.627 66.8382 357.588C66.9687 357.549 67.1063 357.54 67.2409 357.561C67.3765 357.562 67.5077 357.609 67.6132 357.694C67.7187 357.779 67.7924 357.898 67.8222 358.03C67.9752 358.825 66.4657 360.488 65.6803 360.916H65.5987L65.5477 360.937ZM66.7615 358.009C66.2322 358.69 65.9227 359.515 65.8741 360.376C66.6493 359.784 67.6081 358.53 67.5163 358.04C67.5163 358.04 67.5163 357.857 67.2511 357.857H67.1695C67.0191 357.855 66.8736 357.909 66.7615 358.009Z",
    fill: "url(#paint26_linear_484_5341)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M57.1008 343.24H64.6588L64.3324 352.267H56.7744L57.1008 343.24Z",
    fill: "black"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3701 361.294L103.173 362.12L104.631 345.311L96.8389 344.485L95.3701 361.294Z",
    fill: "#B97964"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M103.99 359.611H94.871C94.7208 359.612 94.5754 359.664 94.4587 359.758C94.342 359.853 94.2608 359.984 94.2284 360.131L92.7393 366.863C92.7027 367.004 92.6945 367.151 92.7153 367.296C92.7361 367.44 92.7855 367.579 92.8605 367.704C92.9354 367.83 93.0346 367.939 93.1521 368.025C93.2696 368.112 93.4032 368.174 93.545 368.209H93.7898C96.7579 368.158 98.8897 367.974 102.653 367.974C104.948 367.974 111.833 368.209 115.046 368.209C118.259 368.209 118.626 365.078 117.331 364.792C111.507 363.527 107.131 361.732 105.264 360.09C104.914 359.777 104.459 359.606 103.99 359.611Z",
    fill: "#263238"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M104.511 360.661C104.476 360.652 104.445 360.632 104.422 360.605C104.398 360.578 104.383 360.544 104.378 360.508C104.371 360.473 104.376 360.437 104.393 360.405C104.41 360.373 104.437 360.348 104.47 360.335C104.735 360.162 107.173 358.662 108.009 359.101C108.104 359.142 108.184 359.211 108.238 359.298C108.293 359.385 108.32 359.487 108.315 359.59C108.34 359.77 108.32 359.952 108.255 360.122C108.191 360.291 108.086 360.441 107.948 360.559C107.518 360.846 107.004 360.979 106.49 360.937C105.822 360.916 105.159 360.824 104.511 360.661ZM105.031 360.417C105.914 360.712 106.877 360.661 107.724 360.274C107.813 360.194 107.881 360.094 107.922 359.982C107.963 359.87 107.975 359.749 107.958 359.631C107.958 359.488 107.897 359.427 107.846 359.427C107.779 359.387 107.7 359.369 107.622 359.376C106.712 359.554 105.846 359.908 105.072 360.417H105.031Z",
    fill: "url(#paint27_linear_484_5341)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M104.47 360.702C104.442 360.685 104.419 360.661 104.403 360.632C104.387 360.604 104.378 360.572 104.378 360.539C104.378 360.427 104.572 358.264 105.449 357.55C105.553 357.463 105.673 357.397 105.803 357.357C105.932 357.317 106.069 357.303 106.204 357.316C106.34 357.315 106.472 357.362 106.578 357.447C106.684 357.532 106.757 357.652 106.785 357.785C106.938 358.591 105.429 360.253 104.643 360.671H104.562L104.47 360.702ZM105.673 357.765C105.144 358.441 104.835 359.263 104.786 360.121C105.561 359.539 106.52 358.275 106.428 357.785C106.428 357.785 106.428 357.601 106.163 357.601H106.091C105.937 357.605 105.789 357.663 105.673 357.765Z",
    fill: "url(#paint28_linear_484_5341)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M96.8402 344.485L104.633 345.311L103.868 353.981L96.0752 353.154L96.8402 344.485Z",
    fill: "black"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1931 189.765H100.308C104.113 210.583 116.047 284.235 107.448 349.901L93.8725 348.218C93.8725 348.218 95.127 261.102 83.1526 228.881C81.7756 246.119 80.0927 264.458 78.7157 274.219C75.2274 298.239 67.7612 350.717 67.7612 350.717H53.9814C53.9814 350.717 56.8068 300.473 58.1123 276.871C59.5403 251.219 60.1931 195.028 60.1931 189.765Z",
    fill: "#263238"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M109.038 353.022L92.2393 350.523L92.7594 345.872L110.232 348.167L109.038 353.022Z",
    fill: "url(#paint29_linear_484_5341)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4642 350.808H53.165V345.943L70.0761 345.627L69.4642 350.808Z",
    fill: "url(#paint30_linear_484_5341)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M83.1924 228.851C85.1608 234.497 86.6585 240.297 87.6701 246.19C88.792 230.891 84.3041 214.571 84.3041 214.571L83.1924 228.851Z",
    fill: "black"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0811 196.742L58.1631 201.587C58.1631 201.587 86.2225 205.218 103.674 205.116L103.062 201.791L59.0811 196.742Z",
    fill: "url(#paint31_linear_484_5341)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M116.024 154.791C116.024 154.791 125.724 185.39 132.344 187.43C138.964 189.47 155.803 164.185 155.803 164.185C155.803 164.185 170.929 164.042 171.603 163.012C172.276 161.981 167.676 151.323 166.574 151.313C165.473 151.302 152.295 156.259 151.795 157.096C151.295 157.932 136.169 172.395 135.475 171.967C134.782 171.539 129.029 153.352 129.029 153.352L116.024 154.791Z",
    fill: "#B97964"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M157.804 162.532C157.924 162.508 158.043 162.477 158.161 162.44L157.987 162.328C157.932 162.401 157.87 162.469 157.804 162.532Z",
    fill: "#B97964"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M110.517 151.261L111.7 153.434L117.218 163.634L118.37 165.745L133.864 160.36C133.864 160.36 127.418 136.309 125.184 133.84L110.517 151.261Z",
    fill: "url(#paint32_linear_484_5341)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M110.517 151.261L111.7 153.434L117.218 163.634L118.37 165.745L133.864 160.36C133.864 160.36 127.418 136.309 125.184 133.84L110.517 151.261Z",
    fill: "#E3F4FA"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.7 153.434L117.218 163.634C120.635 156.933 119.646 147.753 119.646 147.753L111.7 153.434Z",
    fill: "black"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M125.184 133.851C122.265 130.48 118.691 127.738 114.679 125.792C110.667 123.845 106.301 122.735 101.847 122.529C86.6697 121.815 81.8963 123.325 76.3476 128.282C68.2389 135.523 58.1514 197.874 58.1514 197.874C72.9504 201.994 88.3238 203.665 103.662 202.821C103.662 202.821 103.846 185.482 109.323 173.844C115.492 160.88 120.79 147.519 125.184 133.851Z",
    fill: "url(#paint33_linear_484_5341)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M58.1514 197.874C72.9504 201.995 88.3233 203.669 103.662 202.831C103.662 202.831 103.662 200.689 103.958 197.415C104.081 195.865 104.264 194.049 104.519 192.091C104.774 190.132 105.141 187.899 105.539 185.675C105.784 184.482 106.07 183.278 106.376 182.085C107.087 179.252 108.057 176.49 109.272 173.833C109.945 172.405 110.598 170.988 111.231 169.6C112.322 167.173 113.362 164.817 114.291 162.563C116.33 157.82 118.064 153.485 119.513 149.691C120.533 146.967 121.451 144.53 122.195 142.439C123.021 140.103 123.674 138.185 124.154 136.757C124.776 134.871 125.082 133.84 125.082 133.84C124.575 133.206 124.03 132.603 123.45 132.035C117.757 126.424 110.232 123.056 102.255 122.549H101.745C90.1784 122.009 84.6604 122.753 80.2337 125.334C78.8063 126.188 77.47 127.186 76.2456 128.312C75.0942 129.56 74.1877 131.013 73.5733 132.596C71.6881 136.98 70.1401 141.501 68.9427 146.121L68.2695 148.599C67.2495 152.383 66.2907 156.412 65.3728 160.492C65.1076 161.655 64.8526 162.818 64.5976 163.97C64.2202 165.745 63.8428 167.51 63.4858 169.254C62.5678 173.65 61.7417 177.913 61.0175 181.748C59.9975 187.256 59.1713 191.866 58.6818 194.733C58.3452 196.752 58.1514 197.874 58.1514 197.874ZM102.724 123.11C103.747 123.136 104.769 123.214 105.784 123.345C109.864 123.896 116.137 127.17 115.984 128.72C115.831 130.27 113.444 134.228 107.345 133.269C105.219 132.877 103.202 132.035 101.429 130.801C98.0628 128.577 95.6149 125.568 95.3701 124.589C95.0641 123.416 99.0216 123.018 102.734 123.131L102.724 123.11Z",
    fill: "#E3F4FA"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6497 143.897C89.6497 143.897 81.6123 163.348 79.96 179.515L101.696 182.289C101.696 182.289 111.446 156.005 113.466 147.784C113.466 147.763 96.1061 146.029 89.6497 143.897Z",
    fill: "url(#paint34_linear_484_5341)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M109.222 148.528L112.241 148.824L110.027 150.537L109.222 148.528Z",
    fill: "#E3F4FA"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3896 124.64C99.0318 129.332 105.141 131.474 108.344 131.78C109.524 131.966 110.731 131.759 111.782 131.192C112.832 130.624 113.667 129.727 114.158 128.639C114.158 128.639 110.496 126.813 110.863 124.763C111.123 123.509 111.637 122.322 112.373 121.274C112.754 120.676 113.17 120.101 113.617 119.551L107.753 106.974C106.447 112.421 102.438 122.886 97.3896 124.64Z",
    fill: "#B97964"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M107.519 112.778C104.724 118.898 108.671 123.11 110.864 124.722C111.124 123.468 111.637 122.281 112.374 121.234L107.519 112.778Z",
    fill: "black"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M127.185 96.4485C127.185 96.4485 129.062 106.811 123.656 110.963C118.25 115.114 117.699 95.7549 117.699 95.7549L127.185 96.4485Z",
    fill: "#B97964"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M127.185 96.4485C127.185 96.4485 129.062 106.811 123.656 110.963C118.25 115.114 117.699 95.7549 117.699 95.7549L127.185 96.4485Z",
    fill: "black"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M107.856 119.683C109.061 121.364 110.785 122.602 112.762 123.208C114.739 123.814 116.86 123.755 118.8 123.039C121.334 122.149 123.432 120.325 124.665 117.939C124.838 117.623 124.991 117.276 125.144 116.919C127.674 110.483 128.204 94.7756 121.391 95.357C115.761 95.8364 110.253 94.1025 107.377 98.9677C106.555 100.352 106.073 101.911 105.969 103.517C105.357 111.024 104.643 115.379 107.856 119.683Z",
    fill: "#B97964"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M116.912 107.229C116.79 107.821 117.076 108.361 117.473 108.423C117.871 108.484 118.259 108.025 118.351 107.403C118.442 106.781 118.177 106.271 117.79 106.22C117.402 106.169 117.004 106.617 116.912 107.229Z",
    fill: "#263238"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M123.736 108.198C123.614 108.79 123.909 109.33 124.297 109.392C124.685 109.453 125.082 108.994 125.164 108.372C125.246 107.75 125.001 107.24 124.603 107.178C124.205 107.117 123.818 107.627 123.736 108.198Z",
    fill: "#263238"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M121.522 108.188C121.982 110.134 122.706 112.008 123.675 113.757C123.218 113.995 122.714 114.13 122.2 114.152C121.686 114.175 121.172 114.086 120.696 113.89L121.522 108.188Z",
    fill: "#A24E3F"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M115.117 104.72C115.179 104.739 115.245 104.74 115.308 104.724C115.371 104.708 115.428 104.675 115.474 104.628C115.786 104.307 116.169 104.062 116.592 103.913C117.015 103.765 117.466 103.716 117.911 103.772C118.004 103.79 118.101 103.772 118.181 103.72C118.261 103.669 118.318 103.589 118.34 103.496C118.35 103.451 118.351 103.403 118.343 103.357C118.334 103.311 118.317 103.268 118.291 103.228C118.265 103.189 118.232 103.156 118.193 103.13C118.154 103.104 118.11 103.087 118.064 103.078C117.51 102.997 116.944 103.047 116.413 103.224C115.881 103.401 115.399 103.701 115.004 104.098C114.938 104.167 114.901 104.258 114.901 104.353C114.901 104.448 114.938 104.54 115.004 104.608C115.037 104.65 115.074 104.688 115.117 104.72Z",
    fill: "#263238"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M127.001 106.261C127.067 106.286 127.139 106.286 127.205 106.261C127.25 106.249 127.293 106.228 127.33 106.199C127.367 106.17 127.397 106.134 127.419 106.093C127.441 106.052 127.454 106.006 127.458 105.96C127.461 105.913 127.455 105.866 127.44 105.822C127.278 105.278 126.988 104.781 126.594 104.373C126.2 103.964 125.713 103.657 125.175 103.476C125.13 103.462 125.083 103.457 125.036 103.462C124.99 103.467 124.945 103.482 124.904 103.504C124.863 103.527 124.827 103.558 124.798 103.595C124.769 103.633 124.748 103.675 124.737 103.721C124.711 103.811 124.723 103.908 124.769 103.99C124.815 104.073 124.891 104.133 124.981 104.159C125.403 104.315 125.783 104.566 126.092 104.893C126.4 105.221 126.627 105.616 126.756 106.046C126.776 106.099 126.809 106.147 126.852 106.184C126.895 106.221 126.946 106.248 127.001 106.261Z",
    fill: "#263238"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M115.964 114.155C115.964 114.155 117.218 116.848 119.779 116.746",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M112.71 95.0918L112.812 98.4169C112.23 98.6281 111.75 99.0515 111.468 99.6022C111.186 100.153 111.123 100.79 111.292 101.385C112.088 104.241 110.119 108.382 107.845 109.892C107.845 109.892 107.845 108.688 106.825 108.872C105.805 109.055 105.488 115.318 107.171 118.47C107.171 118.47 103.571 115.155 102.5 108.453C101.48 102.262 101.674 98.3353 102.5 95.3672L112.71 95.0918Z",
    fill: "#B97964"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M112.71 95.0918L112.812 98.4169C112.23 98.6281 111.75 99.0515 111.468 99.6022C111.186 100.153 111.123 100.79 111.292 101.385C112.088 104.241 110.119 108.382 107.845 109.892C107.845 109.892 107.845 108.688 106.825 108.872C105.805 109.055 105.488 115.318 107.171 118.47C107.171 118.47 103.571 115.155 102.5 108.453C101.48 102.262 101.674 98.3353 102.5 95.3672L112.71 95.0918Z",
    fill: "black"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M101.93 99.0799C105.57 99.4362 109.243 99.2124 112.813 98.4169C123.084 96.3769 127.46 100.151 127.46 100.151C128.171 99.5116 128.731 98.7225 129.099 97.8406C129.468 96.9586 129.636 96.0058 129.592 95.051C129.296 92.0931 125.185 91.5933 125.185 91.5933C125.185 91.5933 123.951 88.258 121.228 87.2482C118.505 86.2384 115.771 88.768 115.771 88.768C115.771 88.768 112.375 85.4837 108.417 86.422C107.085 86.6954 105.887 87.418 105.024 88.4688C104.16 89.5197 103.684 90.8351 103.674 92.1951C103.674 92.1951 99.0334 92.6643 99.1354 95.051C99.2374 97.4377 101.93 99.0799 101.93 99.0799Z",
    fill: "#263238"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M117.707 111.575C119.549 111.575 121.043 109.853 121.043 107.729C121.043 105.606 119.549 103.884 117.707 103.884C115.865 103.884 114.372 105.606 114.372 107.729C114.372 109.853 115.865 111.575 117.707 111.575Z",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M129.427 108.3C129.335 108.939 129.062 109.538 128.639 110.025C128.217 110.513 127.663 110.868 127.044 111.05C126.425 111.232 125.767 111.232 125.148 111.051C124.529 110.869 123.975 110.514 123.553 110.026C123.13 109.539 122.856 108.941 122.764 108.302C122.672 107.664 122.765 107.012 123.033 106.425C123.3 105.838 123.731 105.34 124.273 104.991C124.815 104.642 125.447 104.456 126.092 104.455C127.042 104.528 127.925 104.973 128.549 105.693C129.173 106.413 129.489 107.349 129.427 108.3Z",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M121.034 108.188C121.034 108.188 122.115 107.515 122.758 108.3",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M114.374 107.729L108.529 106.944C107.763 106.845 106.989 107.054 106.377 107.525L106.122 107.729",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M101.868 109.137C102.455 110.931 103.727 112.419 105.408 113.278C107.642 114.39 109.233 112.513 109.008 110.157C108.804 108.056 107.407 104.894 104.928 104.771C104.399 104.754 103.874 104.868 103.401 105.105C102.927 105.341 102.52 105.692 102.216 106.125C101.912 106.559 101.721 107.061 101.661 107.587C101.6 108.113 101.671 108.646 101.868 109.137Z",
    fill: "#B97964"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.5986 164.001C74.2271 160.003 81.8361 143.489 81.8361 143.489L76.3691 140.185L68.9437 146.151L68.2705 148.63C67.2506 152.414 66.2918 156.443 65.3738 160.523C65.1086 161.686 64.8536 162.848 64.5986 164.001Z",
    fill: "black"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M117.626 165.755L134.231 159.656L134.71 161.063L118.095 166.979L117.626 165.755Z",
    fill: "url(#paint35_linear_484_5341)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6026 207.729L26.4697 200.096L21.7624 229.784L69.8952 237.416L74.6026 207.729Z",
    fill: "url(#paint36_linear_484_5341)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4964 211.399L33.7148 216.468L41.4462 224.312",
    stroke: "#E3F4FA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8389 226.117L62.6102 221.048L54.889 213.204",
    stroke: "#E3F4FA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8525 224.852L51.4823 212.664",
    stroke: "#E3F4FA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6059 130.944C70.6059 130.944 52.4607 149.15 49.9923 152.69C47.524 156.229 42.7914 195.467 42.7914 195.467C42.7914 195.467 41.7714 195.814 41.7102 196.661C41.649 197.507 41.547 208.523 41.7102 209.033C41.8734 209.543 50.2167 214.694 51.4509 213.47C52.6851 212.246 54.3986 199.771 54.3986 199.771L49.9923 195.467C49.9923 195.467 55.0922 166.571 58.3255 161.89C61.5588 157.208 74.7368 147.192 74.7368 147.192L70.6059 130.944Z",
    fill: "#B97964"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5495 123.61C87.1912 129.21 85.1819 141.001 80.3064 145.162C75.1479 149.44 69.6945 153.349 63.9869 156.861L55.0928 145.203C55.0928 145.203 64.5581 135.962 70.2903 130.638C74.1891 126.858 79.1772 124.4 84.5495 123.61Z",
    fill: "url(#paint37_linear_484_5341)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M84.5495 123.61C87.1912 129.21 85.1819 141.001 80.3064 145.162C75.1479 149.44 69.6945 153.349 63.9869 156.861L55.0928 145.203C55.0928 145.203 64.5581 135.962 70.2903 130.638C74.1891 126.858 79.1772 124.4 84.5495 123.61Z",
    fill: "#E3F4FA"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0928 144.458L53.9912 145.958L63.2831 158.105L64.5989 157.167L55.0928 144.458Z",
    fill: "url(#paint38_linear_484_5341)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_484_5341",
    x1: 129.755,
    y1: 367.72,
    x2: 203.644,
    y2: 355.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_484_5341",
    x1: 132.265,
    y1: 365.496,
    x2: 199.865,
    y2: 351.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_484_5341",
    x1: 227.132,
    y1: 368.454,
    x2: 288.56,
    y2: 363.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_484_5341",
    x1: 116.843,
    y1: 302.982,
    x2: 415.925,
    y2: 255.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_484_5341",
    x1: 125.696,
    y1: 289.763,
    x2: 405.016,
    y2: 243.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_484_5341",
    x1: 207.12,
    y1: 368.362,
    x2: 229.966,
    y2: 324.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_484_5341",
    x1: 342.909,
    y1: 129.577,
    x2: 346.453,
    y2: 129.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_484_5341",
    x1: 342.909,
    y1: 185.502,
    x2: 346.453,
    y2: 185.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_484_5341",
    x1: 246.185,
    y1: 129.577,
    x2: 249.729,
    y2: 129.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_484_5341",
    x1: 246.185,
    y1: 185.502,
    x2: 249.729,
    y2: 185.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_484_5341",
    x1: 294.552,
    y1: 129.577,
    x2: 298.096,
    y2: 129.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_484_5341",
    x1: 294.552,
    y1: 185.502,
    x2: 298.096,
    y2: 185.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_484_5341",
    x1: 342.909,
    y1: 157.534,
    x2: 346.453,
    y2: 157.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_484_5341",
    x1: 246.185,
    y1: 157.534,
    x2: 249.729,
    y2: 157.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_484_5341",
    x1: 179.54,
    y1: 248.689,
    x2: 180.649,
    y2: 248.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_484_5341",
    x1: 179.53,
    y1: 248.689,
    x2: 220.918,
    y2: 246.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_484_5341",
    x1: 215.341,
    y1: 175.476,
    x2: 218.885,
    y2: 175.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_484_5341",
    x1: 215.341,
    y1: 250.301,
    x2: 218.885,
    y2: 249.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_484_5341",
    x1: 177.929,
    y1: 212.888,
    x2: 181.473,
    y2: 212.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_484_5341",
    x1: 178.704,
    y1: 174.69,
    x2: 180.538,
    y2: 174.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_484_5341",
    x1: 178.704,
    y1: 249.525,
    x2: 180.538,
    y2: 249.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_484_5341",
    x1: 343.929,
    y1: 138.95,
    x2: 356.597,
    y2: 137.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_484_5341",
    x1: 352.863,
    y1: 137.932,
    x2: 354.563,
    y2: 136.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_484_5341",
    x1: 405.048,
    y1: 220.966,
    x2: 486.312,
    y2: 211.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_484_5341",
    x1: 400.595,
    y1: 259.816,
    x2: 454.038,
    y2: 255.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_484_5341",
    x1: 65.4619,
    y1: 361.19,
    x2: 69.6371,
    y2: 360.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_484_5341",
    x1: 65.4658,
    y1: 360.937,
    x2: 68.0765,
    y2: 360.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_484_5341",
    x1: 104.375,
    y1: 360.944,
    x2: 108.547,
    y2: 360.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_484_5341",
    x1: 104.378,
    y1: 360.702,
    x2: 107.044,
    y2: 360.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_484_5341",
    x1: 92.2393,
    y1: 353.022,
    x2: 110.795,
    y2: 347.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_484_5341",
    x1: 53.165,
    y1: 350.808,
    x2: 69.8074,
    y2: 344.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_484_5341",
    x1: 58.1631,
    y1: 205.118,
    x2: 95.4901,
    y2: 182.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_484_5341",
    x1: 110.517,
    y1: 165.745,
    x2: 136.25,
    y2: 163.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_484_5341",
    x1: 58.1514,
    y1: 203.034,
    x2: 131.9,
    y2: 196.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_484_5341",
    x1: 79.96,
    y1: 182.289,
    x2: 116.792,
    y2: 178.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_484_5341",
    x1: 117.626,
    y1: 166.979,
    x2: 135.421,
    y2: 162.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_484_5341",
    x1: 21.7624,
    y1: 229.784,
    x2: 74.984,
    y2: 228.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_484_5341",
    x1: 55.0928,
    y1: 156.861,
    x2: 88.7253,
    y2: 153.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_484_5341",
    x1: 53.9912,
    y1: 158.105,
    x2: 65.6737,
    y2: 157.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebAppContact);
export default __webpack_public_path__ + "static/media/WebApp-Contact.53447cd60257022ad7274b42bef53ff1.svg";
export { ForwardRef as ReactComponent };